var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSingleWhiteCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 11,
  height: 10,
  viewBox: "0 0 11 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2.96375,
  y: 8.45528,
  width: 10.8799,
  height: 1.5009,
  transform: "rotate(-51 2.96375 8.45528)",
  fill: "white"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.12354,
  y: 9.39376,
  width: 5.306,
  height: 1.5,
  transform: "rotate(-141 4.12354 9.39376)",
  fill: "white"
})));
export { SvgSingleWhiteCheck as ReactComponent };
export default __webpack_public_path__ + "23b420ff36d4390e60634622bea4a792.svg";